import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LocationNode } from '../../models/location';
import { ApiResponse } from '@card-software/library';

@Injectable({
  providedIn: 'root',
})
export class LocationProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.inventoryApi + '/api/v1/location';

  public getAll() {
    return this.httpClient.get<ApiResponse<LocationNode[]>>(this.baseUrl + '/all');
  }

  public getByCode(code: string) {
    return this.httpClient.get<ApiResponse<LocationNode>>(`${this.baseUrl}/code/${encodeURIComponent(code)}`);
  }

  public batchGetByCodes(codes: string[], detailed = false) {
    return this.httpClient.post<ApiResponse<LocationNode[]>>(`${this.baseUrl}/code/batch?detailed=${detailed}`, codes);
  }

  public createLocation(location: LocationNode) {
    return this.httpClient.post<ApiResponse<LocationNode>>(this.baseUrl, location);
  }

  public updateLocation(id: string, location: LocationNode) {
    return this.httpClient.put<ApiResponse<LocationNode>>(`${this.baseUrl}/${id}`, location);
  }

  public deleteLocation(id: string) {
    return this.httpClient.delete<ApiResponse<void>>(`${this.baseUrl}/${id}`);
  }

  /** Balance report locations of the selected site (X-Site-Id), in their dropdown order. */
  public getBalanceLocations() {
    return this.httpClient.get<ApiResponse<LocationNode[]>>(`${this.baseUrl}/balance-locations`);
  }

  public getConsumableWarehouses() {
    return this.httpClient.get<ApiResponse<LocationNode[]>>(`${this.baseUrl}/consumable-warehouses`);
  }

  public getAllChildrenLocations(parentLocationCode: string, forItemCode: string | null = null) {
    const url = this.baseUrl + `/children/${encodeURIComponent(parentLocationCode)}`;
    const finalUrl = forItemCode ? `${url}?forItemCode=${encodeURIComponent(forItemCode)}` : url;
    return this.httpClient.get<ApiResponse<LocationNode[]>>(finalUrl);
  }
}
